// extracted by mini-css-extract-plugin
export default {"basic-info-title":"_19r89tj","basicInfoTitle":"_19r89tj","icon-wrapper":"_1rvt4am","iconWrapper":"_1rvt4am"};